<template>
  <q-btn
    :label="label"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import SocialAccountsModal from './AccountsModal.vue';

export default defineComponent({
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: 'Social Accounts',
    },
  },
  methods: {
    openModal() {
      openModal(SocialAccountsModal, { parent: this, clientId: this.clientId });
    },
  },
});
</script>
